import { useNavigate, useParams } from "react-router";
import myContext from "../../../Context/myContext";
import { useContext, useEffect, useState } from "react";
import { Timestamp, doc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { fireDB, storage } from "../../../firebase/FirebaseConfig";
import toast from "react-hot-toast";
import Loader from "../../loader/Loader";

const categoryList = [
    { name: 'fluids' },
    { name: 'printer' },
    { name: 'spareparts' },
    { name: 'machine' },
    { name: 'laptop' },
    { name: 'shoes' },
    { name: 'home' },
    { name: 'books' }
];

const UpdateProductPage = () => {
    const context = useContext(myContext);
    const { loading, setLoading, getAllProductFunction } = context;
    const navigate = useNavigate();
    const { id } = useParams();

    const [product, setProduct] = useState({
        title: "",
        price: "",
        productImageUrl: "",
        category: "",
        description: "",
        time: Timestamp.now(),
        date: new Date().toLocaleString("en-US", {
            month: "short", day: "2-digit", year: "numeric",
        }),
    });

    const [imageFile, setImageFile] = useState(null);

    // Fetch single product data for editing
    const getSingleProductFunction = async () => {
        setLoading(true);
        try {
            const productTemp = await getDoc(doc(fireDB, "products", id));
            const product = productTemp.data();
            setProduct({
                title: product?.title,
                price: product?.price,
                productImageUrl: product?.productImageUrl,
                category: product?.category,
                description: product?.description,
                quantity: product?.quantity,
                time: product?.time,
                date: product?.date,
            });
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    // Handle image upload
    const handleImageUpload = async () => {
        if (!imageFile) return product.productImageUrl;

        const storageRef = ref(storage, `product-images/${imageFile.name}`);
        const uploadTask = uploadBytesResumable(storageRef, imageFile);

        return new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                () => {}, // Optional: Handle progress updates
                (error) => reject(error),
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve(downloadURL);
                }
            );
        });
    };

    // Update product details in Firestore
    const updateProduct = async () => {
        setLoading(true);
        try {
            const imageUrl = await handleImageUpload();
            const updatedProduct = { ...product, productImageUrl: imageUrl };
            console.log("Updated product data: ", updatedProduct);
            await setDoc(doc(fireDB, 'products', id), updatedProduct);
            toast.success("Product Updated successfully");
            getAllProductFunction();
            setLoading(false);
            navigate('/admin-dashboard');
        } catch (error) {
            console.log("Error updating product: ", error);
            setLoading(false);
        }
    };
    

    useEffect(() => {
        getSingleProductFunction();
    }, []);

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    {loading && <Loader />}
                    <div className="card shadow-lg border-0">
                        <div className="card-body">
                            <h2 className="text-center text-primary mb-4">Update Product</h2>

                            {/* Title Input */}
                            <div className="mb-3">
                                <label className="form-label">Product Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={product.title}
                                    onChange={(e) =>
                                        setProduct({ ...product, title: e.target.value })
                                    }
                                    placeholder="Enter product title"
                                />
                            </div>

                            {/* Product short description Input */}
                            <div className="mb-3">
                                <label className="form-label">Product Short Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={product.price}
                                    onChange={(e) =>
                                        setProduct({ ...product, price: e.target.value })
                                    }
                                    placeholder="Enter product short Description"
                                />
                            </div>

                            {/* Image Input */}
                            <div className="mb-3">
                                <label className="form-label">Product Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setImageFile(e.target.files[0])}
                                />
                            </div>

                            {/* Category Input */}
                            <div className="mb-3">
                                <label className="form-label">Product Category</label>
                                <select
                                    className="form-select"
                                    value={product.category}
                                    onChange={(e) =>
                                        setProduct({ ...product, category: e.target.value })
                                    }
                                >
                                    <option disabled>Select Product Category</option>
                                    {categoryList.map((value, index) => (
                                        <option key={index} value={value.name}>
                                            {value.name.charAt(0).toUpperCase() + value.name.slice(1)}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Description Input */}
                            <div className="mb-3">
                                <label className="form-label">Product Description</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    value={product.description}
                                    onChange={(e) =>
                                        setProduct({ ...product, description: e.target.value })
                                    }
                                    placeholder="Enter product description"
                                ></textarea>
                            </div>

                            {/* Update Button */}
                            <div className="d-grid">
                                <button
                                    className="btn btn-primary btn-block"
                                    onClick={updateProduct}
                                >
                                    Update Product
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateProductPage;
